module.exports = __webpack_public_path__ + "static/media/mythological.6d12fb92.png";